export const CREATE_AFFLIATE_DISCOUNT = "affiliates/discounts/create";
